// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"56":"6cc2543d","188":"4a4db314","217":"9c5f9b27","219":"25daba08","315":"cf4df5a5","353":"50bab8b3","382":"5043e583","498":"82a56b11","501":"ae3a2c1f","510":"6c957cfc","528":"cfd7e67d","568":"23a3f9ed","735":"7c17f1ca","784":"4636a54a","787":"d68d295a","892":"67e1cdde"}[chunkId] + ".js";
};